import { Box, Container, Grid } from '@mui/material';

import bigdataBgImg from '@/assets/imgs/home/bigdata_slide_bg.png';
import HomeSubNavigator from './HomeSubNavigator';

export default function BigData() {
  return (
    <Box
      component={'div'}
      className={'home-item bigdata'}
      sx={{
        backgroundImage: `url(${bigdataBgImg})`,
        backgroundSize: 'cover',
      }}
    >
      <Container maxWidth="xl">
        <Box className={'text-right'}>
          <Box className={'t-48 bigdata-title'}>Big Data & AI</Box>
          <Box className={'t-18 bigdata-desc'}>
            <Box>빅데이터의 수집, 관리, 분석 및</Box>
            <Box>AI를 활용한 최신 기술 보유</Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
